import { getContentDispositionFileName } from '@jove-frontend/uikit';

interface UseDownLoadFileProps {
  urlPrefix: string;
  fileIntervalTime: number;
  removeDelayTime: number;
}

/**
 * urlPrefix: all file prefix, for example host
 * fileIntervalTime: batch download file interval time
 * @returns
 */
export const useDownLoadFile = (props?: UseDownLoadFileProps) => {
  const { urlPrefix = '', fileIntervalTime = 200, removeDelayTime = 200 } = props || {};

  /**
   * download file function
   * @param url download url
   * @param delayTime batch download file interval time
   * @param removeTime open to close iframe time
   * @param isLast whether it is last
   * @param isBatchDownload whether is batch download
   */
  const createIframe = (url, delayTime) => {
    // setTimeout(() => {
    //   const downloadIframe = document.createElement('iframe');
    //   downloadIframe.style.display = 'none';
    //   document.body.appendChild(downloadIframe);
    //   try {
    //     downloadIframe.src = url;
    //   } catch (err) {
    //     console.log('download file error', err);
    //   } finally {
    //     document.body.removeChild(downloadIframe);
    //   }
    // }, delayTime);

    setTimeout(() => {
      window.open(url);
    }, delayTime);
  };

  // download func
  const download = (fileUrls) => {
    fileUrls.forEach((item, index) => {
      createIframe(urlPrefix + item, index * fileIntervalTime);
    });
  };

  // download individual file
  const downloadIndividualFile = (url) => {
    if (!url) return;
    download([url]);
  };

  // batch download files
  const batchDownloadFiles = (urls = []) => {
    if (urls?.length === 0) return;
    download(urls);
  };

  // Download the blob file
  const downloadBlobFile = (response, config?: { type?: string }) => {
    if (!response || !response?.data) return;

    // Create blob
    const blob = new Blob([response.data], {
      type: config?.type || 'application/pdf',
    });
    const url = window.URL.createObjectURL(blob);
    // Create a element
    const link = document.createElement('a');
    link.href = url;
    // Get file name
    const filename = getContentDispositionFileName(response.headers['content-disposition']);
    link.download = filename || 'example.pdf';
    // Click download
    document.body.appendChild(link);
    link.click();
    // Clean
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return {
    downloadIndividualFile,
    batchDownloadFiles,
    downloadBlobFile,
  };
};
